import React, { useState, useRef } from 'react'
import { usePopper } from 'react-popper'
import Portal from 'components/Portal'

export const FullBanner = ({ children, ...props }) => {

  return (
    <div {...props} className="bg-positive-darker hover:bg-positive text-white p-4 flex items-center justify-center">
      { children }
    </div>
  )
}

export default FullBanner
